module.exports = __webpack_public_path__ + "img/item5-4.f831488b.jpg";